/* eslint-disable react/prop-types */
import React from 'react';
import _ from 'lodash';
import Img from 'react-cool-img';
import {
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_MOBILE,
  SITE_PLATFORM_WEB_LARGE,
} from 'helpers/BreakpointHelper';
import { isBrowserIE } from 'helpers/GlobalHelper';
import {
  COLLECTION_TYPE_FTSLOCAL,
  COLLECTION_TYPE_SHOWCASE_CAROUSEL,
  COLLECTION_TYPE_SHOWCASE,
  isClip,
} from 'helpers/ContentHelper';

const HIGH_DENSITY_IMAGE_MULTIPLIER = 1.25;

export const BRANDING_LOGO_IMAGE = 'BRANDING_LOGO_IMAGE';
export const COLLECTION_HERO_IMAGE = 'COLLECTION_HERO_IMAGE';
export const COLLECTION_HERO_LOGO_IMAGE = 'COLLECTION_HERO_LOGO_IMAGE';
export const COLLECTION_THUMBNAIL_IMAGE = 'COLLECTION_THUMBNAIL_IMAGE';
export const COLLECTION_THUMBNAIL_LIVE_IMAGE = 'COLLECTION_THUMBNAIL_LIVE_IMAGE';
export const COLLECTION_VIDEO_BANNER_IMAGE = 'COLLECTION_VIDEO_BANNER_IMAGE';
export const EPG_LIVE_IMAGE = 'EPG_LIVE_IMAGE';
export const FOOTER_PROMO = 'FOOTER_PROMO';
export const FUTURE_EPG_MODAL_IMAGE = 'FUTURE_EPG_MODAL_IMAGE';
const HOME_HERO_IMAGE = 'HOME_HERO_IMAGE';
const HOME_SMALL_PROMO_IMAGE = 'HOME_SMALL_PROMO_IMAGE';
const HOME_THUMBNAIL_IMAGE = 'HOME_THUMBNAIL_IMAGE';
export const HOW_TO_WATCH_IMAGE = 'HOW_TO_WATCH_IMAGE';
export const LIVE_EPG_THUMBNAIL_IMAGE = 'LIVE_EPG_THUMBNAIL_IMAGE';
export const LIVE_PLAYER_BACKGROUND_IMAGE = 'LIVE_PLAYER_BACKGROUND_IMAGE';
export const MARKET_VIDEO_IMAGE = 'MARKET_VIDEO_IMAGE';
export const NETWORK_LOGO_IMAGE = 'NETWORK_LOGO_IMAGE';
export const NFT_PROMO = 'NFT_PROMO';
export const NFT_THUMBNAIL_LEFT = 'NFT_THUMBNAIL_LEFT';
export const NFT_THUMBNAIL_RIGHT = 'NFT_THUMBNAIL_RIGHT';
export const PERK_ICON_IMAGE = 'PERK_ICON_IMAGE';
export const POSTER_IMAGE = 'POSTER_IMAGE';
export const POSTER_OVERLAY_IMAGE = 'POSTER_OVERLAY_IMAGE';
export const POSTER_OVERLAY_LOGO_IMAGE = 'POSTER_OVERLAY_LOGO_IMAGE';
export const SEARCH_THUMBNAIL_IMAGE = 'SEARCH_THUMBNAIL_IMAGE';
export const SERIES_DETAIL_HERO_IMAGE = 'SERIES_DETAIL_HERO_IMAGE';
export const SERIES_DETAIL_LOGO_IMAGE = 'SERIES_DETAIL_LOGO_IMAGE';
export const SHOW_DETAIL_CAST_DETAIL_IMAGE = 'SHOW_DETAIL_CAST_DETAIL_IMAGE';
export const SHOW_DETAIL_CAST_ROUND_THUMBNAIL_IMAGE = 'SHOW_DETAIL_CAST_ROUND_THUMBNAIL_IMAGE';
export const SHOW_DETAIL_CAST_THUMBNAIL_LIST_IMAGE = 'SHOW_DETAIL_CAST_THUMBNAIL_LIST_IMAGE';
export const SHOW_DETAIL_FIRST_THUMBNAIL_IMAGE = 'SHOW_DETAIL_FIRST_THUMBNAIL_IMAGE';
export const SHOW_DETAIL_HERO_IMAGE = 'SHOW_DETAIL_HERO_IMAGE';
export const SHOW_DETAIL_RELATED_THUMBNAIL_IMAGE = 'SHOW_DETAIL_RELATED_THUMBNAIL_IMAGE';
export const SHOW_DETAIL_THUMBNAIL_IMAGE = 'SHOW_DETAIL_THUMBNAIL_IMAGE';
export const SHOW_THUMBNAIL_IMAGE = 'SHOW_THUMBNAIL_IMAGE';
export const SMALL_PROMO_IMAGE = 'SMALL_PROMO_IMAGE';
const SPORT_THUMBNAIL_IMAGE = 'SPORT_THUMBNAIL_IMAGE';
export const WATCH_PLAYER_BACKGROUND_IMAGE = 'WATCH_PLAYER_BACKGROUND_IMAGE';
export const WATCH_RELATED_THUMBNAIL_IMAGE = 'WATCH_RELATED_THUMBNAIL_IMAGE';
export const FOX_FALLBACK_IMAGE = '/static/images/FallBack-FOX.jpg';
export const NFT_HERO_BACKGROUND = '/static/images/NFT-hero-background.png';

const getImageSize = ({ context }) => {
  switch (context) {
    case BRANDING_LOGO_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 59 },
        [SITE_PLATFORM_TABLET]: { height: 59 },
        [SITE_PLATFORM_WEB]: { height: 120 },
        [SITE_PLATFORM_WEB_LARGE]: { height: 120 },
      };
    }
    case COLLECTION_HERO_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 568 },
        [SITE_PLATFORM_TABLET]: { width: 768, height: 432 },
        [SITE_PLATFORM_WEB]: { width: 1920, height: 1080 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 1920, height: 1080 },
      };
    }
    case COLLECTION_HERO_LOGO_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 80 },
        [SITE_PLATFORM_TABLET]: { height: 100 },
        [SITE_PLATFORM_WEB]: { height: 100 },
        [SITE_PLATFORM_WEB_LARGE]: { height: 132 },
      };
    }
    case COLLECTION_THUMBNAIL_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 278, height: 156 },
        [SITE_PLATFORM_TABLET]: { width: 356, height: 200 },
        [SITE_PLATFORM_WEB]: { width: 480, height: 270 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 462, height: 260 },
        hover: {
          [SITE_PLATFORM_MOBILE]: { width: 490, height: 276 },
          [SITE_PLATFORM_TABLET]: { width: 490, height: 276 },
          [SITE_PLATFORM_WEB]: { width: 490, height: 276 },
          [SITE_PLATFORM_WEB_LARGE]: { width: 490, height: 276 },
        },
      };
    }

    case COLLECTION_THUMBNAIL_LIVE_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 278, height: 156 },
        [SITE_PLATFORM_TABLET]: { width: 356, height: 200 },
        [SITE_PLATFORM_WEB]: { width: 480, height: 270 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 794, height: 507 },
        hover: {
          [SITE_PLATFORM_MOBILE]: { width: 490, height: 276 },
          [SITE_PLATFORM_TABLET]: { width: 490, height: 276 },
          [SITE_PLATFORM_WEB]: { width: 490, height: 276 },
          [SITE_PLATFORM_WEB_LARGE]: { width: 794, height: 507 },
        },
      };
    }
    case COLLECTION_VIDEO_BANNER_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 540, height: 303 },
        [SITE_PLATFORM_TABLET]: { width: 540, height: 303 },
        [SITE_PLATFORM_WEB]: { width: 540, height: 303 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 540, height: 303 },
      };
    }
    case EPG_LIVE_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 231, height: 130 },
        [SITE_PLATFORM_TABLET]: { width: 231, height: 130 },
        [SITE_PLATFORM_WEB]: { width: 231, height: 130 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 231, height: 130 },
      };
    }
    case FOOTER_PROMO: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 370, height: 208 },
        [SITE_PLATFORM_TABLET]: { width: 1035, height: 582 },
        [SITE_PLATFORM_WEB]: { width: 270, height: 150 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 270, height: 150 },
      };
    }
    case FUTURE_EPG_MODAL_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 536, height: 302 },
        [SITE_PLATFORM_TABLET]: { width: 536, height: 302 },
        [SITE_PLATFORM_WEB]: { width: 536, height: 302 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 536, height: 302 },
      };
    }
    case HOW_TO_WATCH_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 741 },
        [SITE_PLATFORM_TABLET]: { width: 579 },
        [SITE_PLATFORM_WEB]: { width: 741 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 1024 },
      };
    }
    case HOME_HERO_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 375, height: 500 },
        [SITE_PLATFORM_TABLET]: { width: 768, height: 1098 },
        [SITE_PLATFORM_WEB]: { width: 768, height: 1098 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 768, height: 1098 },
      };
    }
    case HOME_SMALL_PROMO_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 375, height: 132 },
        [SITE_PLATFORM_TABLET]: { width: 375, height: 132 },
        [SITE_PLATFORM_WEB]: { width: 1071, height: 359 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 1071, height: 359 },
      };
    }
    case HOME_THUMBNAIL_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 336, height: 189 },
        [SITE_PLATFORM_TABLET]: { width: 349, height: 196 },
        [SITE_PLATFORM_WEB]: { width: 349, height: 196 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 349, height: 196 },
      };
    }
    case LIVE_EPG_THUMBNAIL_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 325, height: 182 },
        [SITE_PLATFORM_TABLET]: { width: 325, height: 182 },
        [SITE_PLATFORM_WEB]: { width: 325, height: 182 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 325, height: 182 },
      };
    }
    case LIVE_PLAYER_BACKGROUND_IMAGE:
    case WATCH_PLAYER_BACKGROUND_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 375, height: 211 },
        [SITE_PLATFORM_TABLET]: { width: 768, height: 432 },
        [SITE_PLATFORM_WEB]: { width: 1135, height: 638 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 1135, height: 638 },
      };
    }
    case MARKET_VIDEO_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 290, height: 163 },
        [SITE_PLATFORM_TABLET]: { width: 463, height: 260 },
        [SITE_PLATFORM_WEB]: { width: 618, height: 347 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 868, height: 488 },
      };
    }
    case NFT_PROMO: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 705, height: 336 },
        [SITE_PLATFORM_TABLET]: { width: 1099, height: 525 },
        [SITE_PLATFORM_WEB]: { width: 1099, height: 525 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 1287, height: 615 },
      };
    }
    case NFT_THUMBNAIL_LEFT: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 200, height: 200 },
        [SITE_PLATFORM_TABLET]: { width: 400, height: 400 },
        [SITE_PLATFORM_WEB]: { width: 768, height: 768 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 768, height: 768 },
      };
    }
    case NFT_THUMBNAIL_RIGHT: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 768, height: 500 },
        [SITE_PLATFORM_TABLET]: { width: 1024, height: 768 },
        [SITE_PLATFORM_WEB]: { width: 1440, height: 1024 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 1440, height: 1024 },
      };
    }
    case SHOW_DETAIL_HERO_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 375, height: 211 },
        [SITE_PLATFORM_TABLET]: { width: 768, height: 432 },
        [SITE_PLATFORM_WEB]: { width: 1920, height: 1080 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 1920, height: 1080 },
      };
    }
    case SHOW_THUMBNAIL_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 222, height: 125 },
        [SITE_PLATFORM_TABLET]: { width: 222, height: 125 },
        [SITE_PLATFORM_WEB]: { width: 245, height: 137 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 245, height: 137 },
      };
    }
    case NETWORK_LOGO_IMAGE:
    case PERK_ICON_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 50 },
        [SITE_PLATFORM_TABLET]: { height: 50 },
        [SITE_PLATFORM_WEB]: { height: 80 },
        [SITE_PLATFORM_WEB_LARGE]: { height: 80 },
      };
    }
    case POSTER_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 174 },
        [SITE_PLATFORM_TABLET]: { height: 287 },
        [SITE_PLATFORM_WEB]: { height: 362 },
        [SITE_PLATFORM_WEB_LARGE]: { height: 597 },
      };
    }
    case POSTER_OVERLAY_LOGO_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 62 },
        [SITE_PLATFORM_TABLET]: { height: 75 },
        [SITE_PLATFORM_WEB]: { height: 85 },
        [SITE_PLATFORM_WEB_LARGE]: { height: 120 },
      };
    }
    case POSTER_OVERLAY_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 132 },
        [SITE_PLATFORM_TABLET]: { height: 132 },
        [SITE_PLATFORM_WEB]: { height: 170 },
        [SITE_PLATFORM_WEB_LARGE]: { height: 219 },
      };
    }
    case SEARCH_THUMBNAIL_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 222, height: 125 },
        [SITE_PLATFORM_TABLET]: { width: 222, height: 125 },
        [SITE_PLATFORM_WEB]: { width: 240, height: 135 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 240, height: 135 },
      };
    }
    case SERIES_DETAIL_HERO_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 575 },
        [SITE_PLATFORM_TABLET]: { height: 620 },
        [SITE_PLATFORM_WEB]: { height: 1250 },
        [SITE_PLATFORM_WEB_LARGE]: { height: 1600 },
      };
    }
    case SERIES_DETAIL_LOGO_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 69 },
        [SITE_PLATFORM_TABLET]: { height: 102 },
        [SITE_PLATFORM_WEB]: { height: 129 },
        [SITE_PLATFORM_WEB_LARGE]: { height: 129 },
      };
    }
    case SHOW_DETAIL_CAST_DETAIL_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 250, height: 250 },
        [SITE_PLATFORM_TABLET]: { width: 250, height: 250 },
        [SITE_PLATFORM_WEB]: { width: 250, height: 250 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 250, height: 250 },
      };
    }
    case SHOW_DETAIL_CAST_ROUND_THUMBNAIL_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { height: 278 },
        [SITE_PLATFORM_TABLET]: { height: 180 },
        [SITE_PLATFORM_WEB]: { height: 312 },
        [SITE_PLATFORM_WEB_LARGE]: { height: 312 },
      };
    }
    case SHOW_DETAIL_CAST_THUMBNAIL_LIST_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 150, height: 150 },
        [SITE_PLATFORM_TABLET]: { width: 150, height: 150 },
        [SITE_PLATFORM_WEB]: { width: 150, height: 150 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 150, height: 150 },
      };
    }
    case SHOW_DETAIL_FIRST_THUMBNAIL_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 335, height: 189 },
        [SITE_PLATFORM_TABLET]: { width: 728, height: 410 },
        [SITE_PLATFORM_WEB]: { width: 728, height: 410 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 728, height: 410 },
      };
    }
    case SHOW_DETAIL_RELATED_THUMBNAIL_IMAGE:
    case SHOW_DETAIL_THUMBNAIL_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 335, height: 189 },
        [SITE_PLATFORM_TABLET]: { width: 728, height: 410 },
        [SITE_PLATFORM_WEB]: { width: 342, height: 192 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 342, height: 192 },
      };
    }
    case SMALL_PROMO_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 733 },
        [SITE_PLATFORM_TABLET]: { width: 1071 },
        [SITE_PLATFORM_WEB]: { width: 1920 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 1920 },
      };
    }
    case SPORT_THUMBNAIL_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 257, height: 145 },
        [SITE_PLATFORM_TABLET]: { width: 257, height: 145 },
        [SITE_PLATFORM_WEB]: { width: 257, height: 145 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 257, height: 145 },
      };
    }
    case WATCH_RELATED_THUMBNAIL_IMAGE: {
      return {
        [SITE_PLATFORM_MOBILE]: { width: 351, height: 198 },
        [SITE_PLATFORM_TABLET]: { width: 351, height: 198 },
        [SITE_PLATFORM_WEB]: { width: 261, height: 147 },
        [SITE_PLATFORM_WEB_LARGE]: { width: 261, height: 147 },
      };
    }

    default: {
      console.warn('image size does not exist', context);
      return {};
    }
  }
};

const generateImageUrl = ({ url, width, height }) => {
  if (!url) return null;
  const defaultSize = '*';
  const imageUrlSuffix = '?fit=inside%7C';
  const imageUrlSize = `${width || defaultSize}:${height || defaultSize}`;
  if (_.includes(url, imageUrlSuffix)) {
    const imageUrl = url.split('?')[0];
    return `${imageUrl}${imageUrlSuffix}${imageUrlSize}`;
  }
  return `${url}${imageUrlSuffix}${imageUrlSize}`.replace(/ /g, '%20');
};

/**
 * @param breakpoint
 * @param context
 * @param url
 * @param isHover
 * @returns {string|null}
 */
export const getDynamicImage = ({
  breakpoint = SITE_PLATFORM_WEB,
  context,
  url,
  isHover = false,
}) => {
  const imageSize = getImageSize({ context });
  const currentImageSize = isHover ? imageSize.hover[breakpoint] : imageSize[breakpoint];
  const { width, height } = currentImageSize;
  const imageUrl = generateImageUrl({ url, width, height });
  return imageUrl || null;
};

const getHighDensityImageUrl = ({ url, width, height }) => {
  if (!url) return null;
  return generateImageUrl({
    url,
    width: Math.round(width * HIGH_DENSITY_IMAGE_MULTIPLIER),
    height: Math.round(height * HIGH_DENSITY_IMAGE_MULTIPLIER),
  });
};

export const getStillBackgroundImage = ({ item, breakpoint }) => {
  if (!item) return null;
  const isMobile = breakpoint === SITE_PLATFORM_MOBILE;
  const collectionType = item?.collectionType;
  const isCollectionShowcase =
    collectionType === COLLECTION_TYPE_SHOWCASE ||
    collectionType === COLLECTION_TYPE_SHOWCASE_CAROUSEL;
  const isCategoryTypeLocal = item?.categoryType === COLLECTION_TYPE_FTSLOCAL;
  const images = _.get(item, 'images', {});
  const autoPlayStill = item?.autoPlayStill;
  const autoPlayStillImage = autoPlayStill?.default?.url ?? null;
  const seriesDetailImage = _.get(item, 'images.seriesDetail.raw', null);
  const stillBackgroundImage = _.get(item, 'images.videoList.raw', null);
  const videoDetailImage = item?.images?.videoDetail?.raw ?? null;
  const mobileImage = item?.images?.keyart_tablet_landscape?.raw ?? null;
  if (isCategoryTypeLocal && isCollectionShowcase && isClip(item?.videoType)) {
    return videoDetailImage || stillBackgroundImage || autoPlayStillImage || seriesDetailImage;
  }

  if (isCollectionShowcase && isMobile && mobileImage) {
    return mobileImage;
  }
  if (stillBackgroundImage) return stillBackgroundImage;

  const { still, seriesList, seriesDetail } = images || {};
  const image = still || seriesDetail || seriesList;
  return _.get(image, 'raw', image);
};

export const renderImage = ({
  alt,
  breakpoint,
  className,
  dataTest,
  lazyLoad = true,
  preventLazyLoad,
  isHover,
  imageType,
  src,
  ...rest
}) => {
  let widthDimn;
  let heightDimn;
  let dynamicImageUrl;
  let highDensityImageUrl;
  const hasDimension = !!imageType && !!breakpoint;
  if (hasDimension) {
    dynamicImageUrl = getDynamicImage({ url: src, breakpoint, context: imageType, isHover });
    const imageSize = getImageSize({ context: imageType });
    const { width, height } = isHover ? imageSize.hover[breakpoint] : imageSize[breakpoint];
    widthDimn = width;
    heightDimn = height;
    highDensityImageUrl = getHighDensityImageUrl({ url: src, width, height });
  }
  const isIE = isBrowserIE();

  const imageProps = {
    alt: alt || '',
    'data-test': dataTest,
    className,
    width: hasDimension ? widthDimn : null,
    height: hasDimension ? heightDimn : null,
    debounce: 300,
    decode: null,
    src: dynamicImageUrl || src,
    srcSet: highDensityImageUrl ? `${highDensityImageUrl} 2x` : highDensityImageUrl,
  };

  if (!lazyLoad) return <img alt={imageProps.alt} {...imageProps} {...rest} />;
  if (isIE) imageProps.decode = false;
  imageProps.lazy = !(preventLazyLoad === true);
  return <Img {...imageProps} {...rest} />;
};
